import { render, staticRenderFns } from "./legalAdvice.vue?vue&type=template&id=76a4c2f4&scoped=true&"
import script from "./legalAdvice.vue?vue&type=script&lang=js&"
export * from "./legalAdvice.vue?vue&type=script&lang=js&"
import style0 from "./legalAdvice.vue?vue&type=style&index=0&id=76a4c2f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4c2f4",
  null
  
)

export default component.exports